<!--
 * @Author: Latte
 * @Date: 2021-09-06 11:45:53
 * @LAstEditors: Latte
 * @LastEditTime: 2021-11-26 09:08:43
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\permission-list\index.vue
-->
<template>
	<div class="app-container">
		<el-card v-loading="loading">
			<el-input class="header_input--filter" v-model="filterText" placeholder="输入关键字进行筛选 "></el-input>

			<el-select v-model="permissionType" clearable @change="permissionTypeChange">
				<el-option label="前端权限" :value="0" :key="0"></el-option>
				<el-option label="后端权限" :value="1" :key="1"></el-option>
			</el-select>

			<el-tree ref="treeRef" :data="menuList" :props="{
          children: 'children',
          label: 'permissionName',
          isLeaf: 'isLeaf',
        }" :filter-node-method="filterNode" node-key="apiPermissionID" :default-expanded-keys="[1]"
				:expand-on-click-node="false">
			</el-tree>
		</el-card>

		<!-- 修改权限对话框 -->
		<!-- <el-dialog
      :title="dialogType === 'create' ? '添加权限' : '修改权限'"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <el-form :model="temp" label-position="top" ref="authorityForm">
        <el-form-item label="接口类型" prop="background">
          <el-radio v-model="temp.background" label="0">后台管理接口</el-radio>
          <el-radio v-model="temp.background" label="1"
            >客户端管理接口</el-radio
          >
        </el-form-item>
        <el-form-item label="接口名称" prop="permissionName">
          <el-input v-model="temp.permissionName"></el-input>
        </el-form-item>
        <el-form-item label="接口描述" prop="remarks">
          <el-input v-model="temp.remarks"></el-input>
        </el-form-item>
        <el-form-item label="请求方法" prop="requestMethod">
          <el-select v-model="temp.requestMethod">
            <el-option
              v-for="item in requestMethodOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">
          取 消
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="dialogType === 'create' ? createAuthority() : editAuthority()"
        >
          确 定
        </el-button>
      </div>
    </el-dialog> -->
	</div>
</template>

<script>
	import {
		getAllPermissionList,
		getAllPermissionListWithOption
	} from "@/api/permission";

	import {
		isVaild
	} from "@/utils/validate"
	export default {
		name: "MenuManagement",
		data() {
			return {
				menuList: [],
				loading: false,
				filterText: "",
				permissionType: "",
				// dialogType: "",
				// dialogVisible: false,
				// temp: {},
				// requestMethodOptions: Object.freeze([
				//   { label: "查询数据", value: "0" },
				//   { label: "新增数据", value: "1" },
				//   { label: "完全更新数据", value: "2" },
				//   { label: "部分更新数据", value: "3" },
				//   { label: "查询数据", value: "4" },
				// ]),
			};
		},
		watch: {
			filterText(val) {
				this.$refs.treeRef.filter(val);
			},
		},
		created() {
			// this.menuList = MENU_LIST
			this.refreshList();
		},
		methods: {
			permissionTypeChange() {
				// this.refreshList();
				this.$refs.treeRef.filter(this.filterText);
			},
			refreshList() {
				this.getPermissionList(-1);
			},
			async getPermissionList(belongToIndex) {
				this.loading = true;
				const result = await getAllPermissionListWithOption({
					background: -1, //获取全部，前后端权限在前端做筛选
					belongToIndex: belongToIndex
				});

				this.menuList = this.formatPermissionList(result.data);
				// this.filterText = ""

				this.loading = false;
			},

			/**
			 * @description: 格式化权限列表
			 * @param {*} arr
			 * @return {*}
			 */
			formatPermissionList(arr) {
				if (arr == null) {
					return []
				}
				const newArr = arr.map((item, index) => {
					const newItem = {
						apiPermissionID: item.apiPermissionID,
						permissionName: item.permissionName + (isVaild(item.remarks) ? " - " + item
							.remarks : ""),
						children: this.formatPermissionList(item.childList),
						isLeaf: item.childList == null || item.childList.length === 0,
						background: item.background
					};
					return newItem;
				});

				return newArr;
			},

			/**
			 * @description: 筛选节点
			 * @param {*} value
			 * @param {*} data
			 * @return {*}
			 */
			filterNode(value, data, node) {
				// if (!value) return true;
				let backgroudFilter = (isVaild(this.permissionType) ? data.background ===
					this.permissionType : true);
				return data.permissionName.indexOf(value) !== -1 && backgroudFilter;
			},
			/**
			 * @description: 编辑权限
			 * @param {*} node
			 * @param {*} row
			 * @return {*}
			 */
			handleEditAuthority(node, data) {
				this.dialogType = "edit";
				this.dialogVisible = true;
				console.log(node, data);
				this.temp = {
					...data
				};
			},
		},
	};
</script>

<style lang="scss" scoped>
	.app-container {
		.header_input--filter {
			margin-bottom: 20px;
		}

		::v-deep .el-tree-node__content {
			height: 40px;
		}

		.custom-tree-node {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-right: 8px;
		}
	}
</style>
